import { z } from 'zod';
export const MenuItemInputSchema = z.object({
    recipeId: z.string().min(1),
    servings: z.number().int().min(1).max(50),
});
export const MenuItemUpdateSchema = z.object({
    servings: z.number().int().min(1).max(50).optional(),
    order: z.number().int().nonnegative().optional(),
});
export const MenuInputSchema = z.object({
    name: z.string().trim().max(120).nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
});
export const MenuUpdateSchema = MenuInputSchema;
export const MenuItemSchema = z.object({
    id: z.string(),
    recipeId: z.string(),
    servings: z.number().int(),
    order: z.number().int(),
    recipe: z.object({
        id: z.string(),
        name: z.string(),
        icon: z.string().nullable().optional(),
        category: z.string().nullable().optional(),
        coverImage: z.string().nullable().optional(),
        baseServings: z.number().int(),
        prepTime: z.number().int().nullable().optional(),
    }),
});
export const AggregatedIngredientSchema = z.object({
    key: z.string(),
    name: z.string(),
    unit: z.string().nullable(),
    totalQuantity: z.number(),
    sources: z.array(z.object({
        recipeId: z.string(),
        recipeName: z.string(),
        quantity: z.number(),
    })),
});
export const MenuSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    notes: z.string().nullable(),
    sentAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    items: z.array(MenuItemSchema),
    aggregated: z.array(AggregatedIngredientSchema).optional(),
});
export const MenuListItemSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    sentAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    itemsCount: z.number().int(),
    recipePreviews: z.array(z.object({
        id: z.string(),
        name: z.string(),
        icon: z.string().nullable().optional(),
    })),
});
export const SendMenuToBringSchema = z.object({
    excludedKeys: z.array(z.string()).default([]),
});
//# sourceMappingURL=menu.js.map